import dayjs from 'dayjs';
import { email } from '@vuelidate/validators';

type ProfileData = Record<string, unknown>;

export function hasProfileValue(value: unknown): boolean {
	return typeof value === 'string' ? Boolean(value.trim()) : Boolean(value);
}

export function isProfileMinor(value: unknown): boolean {
	if (!value) return false;
	const birthdate = dayjs(value as string | Date).startOf('day');
	const today = dayjs().startOf('day');
	return birthdate.isValid() && !birthdate.isAfter(today) && today.diff(birthdate, 'year') < 18;
}

export function emergencyContactErrors(data: ProfileData) {
	return {
		emergencyFirstName: hasProfileValue(data['emergencyFirstName']) ? '' : 'Enter an emergency contact first name.',
		emergencyLastName: hasProfileValue(data['emergencyLastName']) ? '' : 'Enter an emergency contact last name.',
		emergencyRelation: hasProfileValue(data['emergencyRelation']) ? '' : 'Select an emergency contact relationship.',
		emergencyPhone: hasProfileValue(data['emergencyPhone']) ? '' : 'Enter an emergency contact phone number.'
	};
}

export function mailingAddressErrors(data: ProfileData) {
	return {
		addressLine1: hasProfileValue(data['addressLine1']) ? '' : 'Enter your street address.',
		city: hasProfileValue(data['city']) ? '' : 'Enter your city.',
		state: hasProfileValue(data['state']) ? '' : 'Enter your state.',
		postalCode5: hasProfileValue(data['postalCode5']) ? '' : 'Enter your ZIP code.'
	};
}

export function parentalContactErrors(data: ProfileData) {
	const required = isProfileMinor(data['birthdate']);
	return {
		parentalFirstName: required && !hasProfileValue(data['parentalFirstName']) ? 'Enter a parent or guardian first name.' : '',
		parentalLastName: required && !hasProfileValue(data['parentalLastName']) ? 'Enter a parent or guardian last name.' : '',
		parentalPhone: required && !hasProfileValue(data['parentalPhone']) ? 'Enter a parent or guardian phone number.' : '',
		parentalEmail: !required ? '' : !hasProfileValue(data['parentalEmail']) ? 'Enter a parent or guardian email address.' : !email.$validator(data['parentalEmail'] as string, data, {}) ? 'Enter a valid email address.' : ''
	};
}
